import { updateActiveBaseMapInSettings } from '../../WMSLayers/useWMSSettings';
import * as z from 'zod';
import { useSaveSettings } from '@ais-ui/websockets';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useToast } from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';
import { useSettings } from '../SettingsProvider';

const activateBaseMapFormSchema = z.object({
  active_base_map: z.string(),
});

export type ActivateBaseMapFormValues = z.infer<
  typeof activateBaseMapFormSchema
>;

export const useActivateBaseMapForm = () => {
  const { toast } = useToast();
  const { messages } = useLocalization();
  const { settings } = useSettings();
  const { mutate: mutateSettings } = useSaveSettings();

  const form = useForm<ActivateBaseMapFormValues>({
    resolver: zodResolver(activateBaseMapFormSchema),
    defaultValues: {
      active_base_map: settings['ribbonPlugin.settings'].active_base_map
        ? settings['ribbonPlugin.settings'].active_base_map
        : '',
    },
  });

  const onSubmit = (data: ActivateBaseMapFormValues) => {
    const settingsToSave = updateActiveBaseMapInSettings(
      data.active_base_map,
      settings,
    );

    mutateSettings(settingsToSave, {
      onSuccess: () => {
        toast({
          className: 'update-base-map-enable-success-toast',
          title: messages.genericToastTitleSuccess,
          description: data.active_base_map
            ? messages.settingsBaseMapSuccessEnabledMessage
            : messages.settingsBaseMapSuccessDisabledMessage,
        });
      },
      onError: () => {
        toast({
          className: 'update-base-map-layer-settings-error-toast',
          title: messages.genericToastTitleError,
          description: data.active_base_map
            ? messages.settingsBaseMapFailedEnabledMessage
            : messages.settingsBaseMapFailedDisabledMessage,
          variant: 'destructive',
        });
      },
    });
  };

  return {
    form,
    onSubmit,
  };
};
